<template>
  <svg
    fill="none"
    height="16"
    viewBox="0 0 16 16"
    width="16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_17888_163075)">
      <circle
        cx="7.9987"
        cy="7.9987"
        r="6.66667"
        stroke="#6D798A"
      />
      <path
        d="M6.33203 6.33203L8.66528 8.66512M10.6654 5.33203L7.33203 8.66536"
        stroke="#6D798A"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_17888_163075">
        <rect
          fill="white"
          height="16"
          width="16"
        />
      </clipPath>
    </defs>
  </svg>
</template>
